export const createUrl = (
  urlOrPath: string,
  params?: Record<string, string>,
  excludeExistingParams = false,
): string => {
  // Determine if the input is a URL or a path by checking if it includes "://"
  const isUrl = urlOrPath.includes('://');
  let base = urlOrPath;

  if (!isUrl && typeof window !== 'undefined') {
    base = `${window.origin}/${
      urlOrPath.startsWith('/') ? urlOrPath.slice(1) : urlOrPath
    }`;
  }
  const url = new URL(base);

  // If excluding existing parameters, clear them
  if (excludeExistingParams) {
    url.search = '';
  }

  if (params) {
    const searchParams = new URLSearchParams(params);
    searchParams.forEach((value, key) => {
      url.searchParams.set(key, value);
    });
  }

  return url.toString();
};

export const getSlug = (url = window.location.href) => {
  try {
    const urlObject = new URL(url);
    const pathSegments = urlObject.pathname
      .split('/')
      .filter(segment => segment !== '');
    return pathSegments[pathSegments.length - 1] || '';
  } catch {
    return '';
  }
};

export const getUrlLocale = (url = location.href) => {
  try {
    const pathSegments = new URL(url).pathname.split('/');
    const lastSegment = pathSegments[pathSegments.length - 1];
    const locale = lastSegment.split('-')[0];
    return locale;
  } catch {
    return '';
  }
};

export function getUrlParameters(): Record<string, string>;
export function getUrlParameters(param: string, fallback?: string): string;
export function getUrlParameters(
  param?: string,
  fallback = '',
): Record<string, string> | string {
  const urlParams = new URLSearchParams(window.location.search);
  const params: Record<string, string> = {};

  for (const [key, value] of urlParams.entries()) {
    params[key] = value;
  }

  if (typeof param === 'string' && param.length > 0) {
    return params[param] || fallback;
  }
  return params;
}

export const appendUrlParams = (params: Record<string, string>): void => {
  const url = new URL(window.location.href);
  let isUrlUpdated = false;

  // Iterate over the parameters to add or update them
  Object.entries(params).forEach(([key, value]) => {
    if (!url.searchParams.has(key)) {
      url.searchParams.append(key, value);
      isUrlUpdated = true;
    } else if (url.searchParams.get(key) !== value) {
      url.searchParams.set(key, value);
      isUrlUpdated = true;
    }
  });

  if (isUrlUpdated) {
    window.history.pushState({}, '', url.toString());
  }
};

export const removeUrlParams = (paramsToRemove: string | string[]): void => {
  const url = new URL(window.location.href);
  let isParamRemoved = false;
  const params = Array.isArray(paramsToRemove)
    ? paramsToRemove
    : [paramsToRemove];

  params.forEach(param => {
    if (url.searchParams.has(param)) {
      url.searchParams.delete(param);
      isParamRemoved = true;
    }
  });
  if (isParamRemoved) {
    window.history.pushState({}, '', url.toString());
  }
};
